import { render } from "./MailSettings.vue?vue&type=template&id=0c717832"
import script from "./MailSettings.vue?vue&type=script&lang=js"
export * from "./MailSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__